import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { Clock } from "lucide-react";

// Tlačítko "Odložit" s menu voleb (1h / 12h / 24h / 3 dny).
// Menu se renderuje přes PORTÁL na <body> s position:fixed + vysokým z-indexem,
// aby ho nikdy neořízl rodič s overflow-hidden ani nezakryl spodní tab bar.
// Když je tlačítko u spodního okraje, menu se překlopí nad něj.
const OPTS = [
  { l: "o 1 hodinu", o: { hours: 1 } },
  { l: "o 12 hodin", o: { hours: 12 } },
  { l: "o 24 hodin", o: { hours: 24 } },
  { l: "o 3 dny", o: { days: 3 } },
];

export default function SnoozeButton({ onPick, disabled, size = "sm" }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const btnRef = useRef(null);

  const toggle = () => {
    if (open) { setOpen(false); return; }
    const r = btnRef.current?.getBoundingClientRect();
    if (!r) return;
    const menuH = 210, menuW = 180;
    const below = r.bottom + menuH < window.innerHeight - 80;
    setPos({
      top: below ? r.bottom + 6 : Math.max(8, r.top - menuH - 6),
      left: Math.max(8, Math.min(r.right - menuW, window.innerWidth - menuW - 8)),
    });
    setOpen(true);
  };
  const pick = (o) => { setOpen(false); onPick(o); };

  const btnPad = size === "lg" ? "px-3.5 py-2.5 text-sm" : "px-3 py-2 sm:px-2.5 sm:py-1.5 text-sm sm:text-xs";

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        onClick={toggle}
        disabled={disabled}
        className={`inline-flex items-center gap-1 font-semibold rounded-xl bg-slate-50 text-slate-600 border border-slate-200 hover:bg-slate-100 active:bg-slate-200 disabled:opacity-50 transition-colors ${btnPad}`}
      >
        <Clock className="w-4 h-4 sm:w-3.5 sm:h-3.5" /> Odložit
      </button>
      {open && pos && createPortal(
        <>
          <div className="fixed inset-0 z-[90]" onClick={() => setOpen(false)} />
          <div
            className="fixed z-[100] bg-white border border-slate-200 rounded-xl shadow-2xl py-1 w-44 overflow-hidden"
            style={{ top: pos.top, left: pos.left }}
          >
            {OPTS.map((x) => (
              <button
                key={x.l}
                type="button"
                onClick={() => pick(x.o)}
                className="w-full text-left px-4 py-3 sm:py-2 text-sm text-slate-700 hover:bg-brand-50 active:bg-brand-100 transition-colors"
              >
                {x.l}
              </button>
            ))}
          </div>
        </>,
        document.body
      )}
    </>
  );
}
